import { render, staticRenderFns } from "./WidgetDetailsView.vue?vue&type=template&id=0dc1b07a&scoped=true&"
import script from "./WidgetDetailsView.vue?vue&type=script&lang=js&"
export * from "./WidgetDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDetailsView.vue?vue&type=style&index=0&id=0dc1b07a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc1b07a",
  null
  
)

export default component.exports